import {na, naNonFinal, pvar, showNonFinal} from '../utils/prescription_functions';

const PREFIX_RH = 'HP_RH_SFC';
const PREFIX_T = 'HP_T_SFC';
const PREFIX_WIND_MAG_KTS = 'HP_WindMag_SFC';
const PREFIX_KBDI = 'HP_KBDI_SFC';
const PREFIX_CURING = 'HP_Curing_SFC';

const CODE = {
  DRY_SCLEROPHYLL_REGROWTH_WITHOUT_WIREGRASS: 'd60a7114-deb4-4690-ab38-21c3987274c6',
  DRY_SCLEROPHYLL_MATURE_WITHOUT_WIREGRASS: '54d3fc00-992b-4ecc-a0ba-b5581e2b2677',
  DRY_SCLEROPHYLL_MATURE_WITHOUT_WIREGRASS_SLASH: '72cb2a95-843a-4549-8b0a-46baddb62440',
  WIREGRASS_REGROWTH: 'd3f8be24-1b13-4777-bd51-3952285abf0b',
  WIREGRASS_MATURE: '618c7d77-bce1-476f-8737-6b812ba529f1',
  HEATHLANDS: '077b0d96-cb66-4a53-b03f-12d8e78d58b7',
  MALLEE: '253bc6e5-3eab-4a9b-800d-6d6f093c2c2b',
  GRASSLANDS: 'dd0f8ddc-cefc-4867-9565-9ca2bcc59ff6',
  ASH: '33a1ec66-d269-4339-8f19-16a5d4f79625',
  SOFTWOOD: 'f4a8dbd3-767b-4366-be8e-346a253a7e82',
  WINDROS_DRY_SCLEROPHYLL: 'a5076298-ed3b-46bb-ae16-39cd903c5e55',
  WINDROS_ASH: '6eb066ec-866a-4c0d-80da-13fc773047ea',
  WINDROS_SOFTWOOD: '744c6183-54c0-4cad-bd9e-be302f0f277c',
  HEADS_DISPOSAL: '74aef4f5-19cf-49f5-b5ce-4922cbe1daf2',
  CFA_GRASSLANDS: '570dc423-991f-40b1-80df-85c783045b60',
  GIPPSLAND_LOW_INTENSITY: 'cf5e9561-11c8-4572-b24d-b142bdae9b9a',
  MATURE_COASTAL_TEA_TREE: '41f25da0-026d-4b31-a3cd-bb2ffd7e42ae',
  MIDLANDS_DRY_WITH_WIREGRASS: 'e82b1f4e-5a57-42ff-ba33-49b8502a3610',
  MIDLANDS_DRY_WITHOUT_WIREGRASS: '2a8f8151-cc0a-4e4a-b27a-55d66722ab58',
  MILDURA_HEATH_CONTINOUS: 'f8114ed3-4d56-4c88-8425-8c2ebe67cba4',
  MILDURA_HEATH_CONTINOUS_UNBOUNDED: '35522706-73e8-40ce-ac93-181667c63c55',
  MILDURA_HEATH_DISCONTINUOS: 'ea86bc15-5672-47de-80db-63d458f00df8',
  MILDURA_HEATH_DISCONTINUOS_UNBOUNDED: 'a796af4d-7337-476b-a74d-a073a132a1b6',
  MILDURA_MALLEE_WITH_TRIODIA: 'ba5e29a1-0420-40f3-b55f-6557e1fc7919',
  MILDURA_MALLEE_WITH_TRIODIA_UNBOUNDED: '83840d1f-0bb6-4e7e-b2e0-e7658e22f7e0',
  MILDURA_MALLEE_WITHOUT_TRIODIA: 'ba558131-2281-4701-8efe-aee4cb5e0168',
  MILDURA_MALLEE_WITHOUT_TRIODIA_UNBOUNDED: '82a0c64d-01c7-45c5-a967-b88fab97393f',
  GOLDFIELDS_IRONBARK: 'fa763913-4c1e-41ea-bb36-003b6f1ac083',
  GOLDFIELDS_STRINGYBARK: '78480a5f-edf6-4d94-b53d-bc7e76333005',
  GOLDFIELDS_MIXED: '48547fd0-743c-4d19-ab42-d625001d89a0',
  MURRINDINDI_STRINGYBARK: '0afe862b-3ff7-457e-b71f-8c1712b4a6bf',
  MURRINDINDI_DRY_SCLEROPHYLL: '33687793-5f7a-4b40-a037-d8856458aa2c',
  MURRINDINDI_MIXED: '7d559c9c-c7c7-4fec-af1f-44644a1cdace',
  NE_HIGH_INTENSITY: '417515f9-6e0a-43b7-a575-57f34c2daffa',
  NE_REDGUM: 'a94233cf-33a2-4cd3-b9a0-46df25d90655',
  OTWAY_AREA_COASTAL: 'a162ead9-33e5-45be-9910-96fe45ae9e4d',
  OTWAY_AREA_HEATH: '0097a499-4c00-45b0-99db-c31f949e82ac',
  OTWAY_HEAD_COASTAL: '0aab343e-4208-4196-926d-cfee8e5bbc33',
  OVENS_DRY_SCLEROPHYLL: '7032ceea-e47c-423c-a2c0-2b5457ec289d',
  PORT_PHILLIP_LOW_HAZARD: '3ce1bd64-ce46-41e2-b807-f0d0f4755a55',
  PORT_PHILLIP_CANDLING_MOD_TO_EXTREME: 'f84bb144-8028-468a-a6e4-49f3e93d5763',
  PORT_PHILLIP_FUEL_REDUCTION: 'eddeee07-e095-495e-aec6-fc22f799ba98'
};

export const PRESCRIPTIONS_ENUM = {
  'Dry sclerophyll forest (regrowth, without wiregrass)': CODE.DRY_SCLEROPHYLL_REGROWTH_WITHOUT_WIREGRASS,
  'Dry sclerophyll forest (mature, without wiregrass)': CODE.DRY_SCLEROPHYLL_MATURE_WITHOUT_WIREGRASS,
  'Dry sclerophyll forest (mature, without wiregrass) - Slash': CODE.DRY_SCLEROPHYLL_MATURE_WITHOUT_WIREGRASS_SLASH,
  'Wiregrass - regrowth forest': CODE.WIREGRASS_REGROWTH,
  'Wiregrass - mature forest': CODE.WIREGRASS_MATURE,
  'Heathlands (coastal, foothill, mountain)': CODE.HEATHLANDS,
  'Mallee, desert heaths, Hummock grasslands': CODE.MALLEE,
  'Grasslands': CODE.GRASSLANDS,
  'Ash, HEMS logging slash': CODE.ASH,
  'Softwood slash': CODE.SOFTWOOD,
  'Windrows - Dry sclerophyll forest': CODE.WINDROS_DRY_SCLEROPHYLL,
  'Windrows - Ash/HEMS Logging slash': CODE.WINDROS_ASH,
  'Windrows - Softwood Logging slash': CODE.WINDROS_SOFTWOOD,
  'Heads disposal': CODE.HEADS_DISPOSAL,
  'CFA Grasslands': CODE.CFA_GRASSLANDS,
  'Gippsland - Low intensity (mixed species)': CODE.GIPPSLAND_LOW_INTENSITY,
  'Mature Coastal Tea Tree': CODE.MATURE_COASTAL_TEA_TREE,
  'Midlands - Dry sclerophyll forest (regrowth, with wiregrass)': CODE.MIDLANDS_DRY_WITH_WIREGRASS,
  'Midlands - Dry sclerophyll forest (regrowth, without wiregrass)': CODE.MIDLANDS_DRY_WITHOUT_WIREGRASS,
  'Mildura - Heath continuous fuel': CODE.MILDURA_HEATH_CONTINOUS,
  'Mildura - Heath continuous fuel unbounded': CODE.MILDURA_HEATH_CONTINOUS_UNBOUNDED,
  'Mildura - Heath discontinuous fuel': CODE.MILDURA_HEATH_DISCONTINUOS,
  'Mildura - Heath discontinuous fuel unbounded': CODE.MILDURA_HEATH_DISCONTINUOS_UNBOUNDED,
  'Mildura - Mallee continuous fuel with triodia': CODE.MILDURA_MALLEE_WITH_TRIODIA,
  'Mildura - Mallee continuous fuel with triodia unbounded': CODE.MILDURA_MALLEE_WITH_TRIODIA_UNBOUNDED,
  'Mildura - Mallee continuous fuel without triodia': CODE.MILDURA_MALLEE_WITHOUT_TRIODIA,
  'Mildura - Mallee continuous fuel without triodia unbounded': CODE.MILDURA_MALLEE_WITHOUT_TRIODIA_UNBOUNDED,
  'Murray Goldfields - Box ironbark forest': CODE.GOLDFIELDS_IRONBARK,
  'Murray Goldfields - Box stringybark forest': CODE.GOLDFIELDS_STRINGYBARK,
  'Murray Goldfields - Mixed species': CODE.GOLDFIELDS_MIXED,
  'Murrindindi - Candling (stringybark forest)': CODE.MURRINDINDI_STRINGYBARK,
  'Murrindindi - Dry sclerophyll forest (regrowth, without wiregrass)': CODE.MURRINDINDI_DRY_SCLEROPHYLL,
  'Murrindindi - Mixed species 2009  footprint': CODE.MURRINDINDI_MIXED,
  'North East - High intensity': CODE.NE_HIGH_INTENSITY,
  'North East - Redgum forest and woodland': CODE.NE_REDGUM,
  'Otway Broad Area - Coastal and foothill mixed species': CODE.OTWAY_AREA_COASTAL,
  'Otway Broad Area - Heath and heathy woodland': CODE.OTWAY_AREA_HEATH,
  'Otway Head Burning - Coastal and foothill mixed species': CODE.OTWAY_HEAD_COASTAL,
  'Ovens - Dry sclerophyll forest (regrowth, without wiregrass)': CODE.OVENS_DRY_SCLEROPHYLL,
  'Port Phillip Candling - Low Fuel Hazard': CODE.PORT_PHILLIP_LOW_HAZARD,
  'Port Phillip Candling - Moderate to Extreme Fuel Hazard': CODE.PORT_PHILLIP_CANDLING_MOD_TO_EXTREME,
  'Port Phillip Fuel Reduction': CODE.PORT_PHILLIP_FUEL_REDUCTION
};

export const PRESCRIPTIONS_CONFIG = {
  [CODE.DRY_SCLEROPHYLL_REGROWTH_WITHOUT_WIREGRASS]: {
    FFDI: showNonFinal(),
    GFDI: naNonFinal(),
    D1FDI: pvar('MAX_FFDI_DAY1', null, 8, 'Max FDI'),
    D2FDI: na(),
    TEMP: pvar(PREFIX_T, null, 25, 'Temp'),
    RH: pvar(PREFIX_RH, 35, 70, 'RH', null, true),
    WND10: pvar(PREFIX_WIND_MAG_KTS, null, 20, 'Wind'),
    D1WND10: pvar('MAX_WindMagKmh_SFC', null, 20, 'Max Wind'),
    WND1p5: pvar('DIV_WRF_' + PREFIX_WIND_MAG_KTS, null, 12.5, 'Wind'),
    D1WND1p5: pvar('DIV_WRF_MAX_WindMagKmh_SFC', null, 12.5, 'Max Wind'),
    KBDI: pvar(PREFIX_KBDI, null, 50, 'KBDI'),
    FMC: pvar('FMC', 9, 16, 'L80 FMC', null, true),
    DP: na(),
    CURE: na()
  },
  [CODE.DRY_SCLEROPHYLL_MATURE_WITHOUT_WIREGRASS]: {
    FFDI: showNonFinal(),
    GFDI: naNonFinal(),
    D1FDI: pvar('MAX_FFDI_DAY1', null, 10, 'Max FDI'),
    D2FDI: pvar('MAX_FFDI_DAY2', null, 12, 'Max FDI'),
    TEMP: pvar(PREFIX_T, 18, 27, 'Temp'),
    RH: pvar(PREFIX_RH, 35, 70, 'RH', null, true),
    WND10: pvar(PREFIX_WIND_MAG_KTS, null, 20, 'Wind'),
    D1WND10: pvar('MAX_WindMagKmh_SFC', null, 20, 'Max Wind'),
    WND1p5: pvar('DIV_WRF_' + PREFIX_WIND_MAG_KTS, null, 12.5, 'Wind'),
    D1WND1p5: pvar('DIV_WRF_MAX_WindMagKmh_SFC', null, 12.5, 'Max Wind'),
    KBDI: pvar(PREFIX_KBDI, null, 50, 'KBDI'),
    FMC: pvar('FMC', 9, 16, 'L80 FMC', null, true),
    DP: na(),
    CURE: na()
  },
  [CODE.DRY_SCLEROPHYLL_MATURE_WITHOUT_WIREGRASS_SLASH]: {
    FFDI: showNonFinal(),
    GFDI: naNonFinal(),
    D1FDI: pvar('MAX_FFDI_DAY1', null, 10, 'Max FDI'),
    D2FDI: pvar('MAX_FFDI_DAY2', null, 12, 'Max FDI'),
    TEMP: pvar(PREFIX_T, 18, 27, 'Temp'),
    RH: pvar(PREFIX_RH, 35, 70, 'RH', null, true),
    WND10: pvar(PREFIX_WIND_MAG_KTS, null, 20, 'Wind'),
    D1WND10: pvar('MAX_WindMagKmh_SFC', null, 20, 'Max Wind'),
    WND1p5: pvar('DIV_WRF_' + PREFIX_WIND_MAG_KTS, null, 12.5, 'Wind'),
    D1WND1p5: pvar('DIV_WRF_MAX_WindMagKmh_SFC', null, 12.5, 'Max Wind'),
    KBDI: pvar(PREFIX_KBDI, null, 50, 'KBDI'),
    FMC: pvar('FMC', null, 14, 'L80 FMC', null, true),
    DP: na(),
    CURE: na()
  },
  [CODE.WIREGRASS_REGROWTH]: {
    FFDI: showNonFinal(),
    GFDI: naNonFinal(),
    D1FDI: pvar('MAX_FFDI_DAY1', null, 5, 'Max FDI'),
    D2FDI: na(),
    TEMP: pvar(PREFIX_T, null, 22, 'Temp'),
    RH: pvar(PREFIX_RH, 60, null, 'RH', null, true),
    WND10: pvar(PREFIX_WIND_MAG_KTS, null, 15, 'Wind'),
    D1WND10: pvar('MAX_WindMagKmh_SFC', null, 15, 'Max Wind'),
    WND1p5: pvar('DIV_WRF_' + PREFIX_WIND_MAG_KTS, null, 9.4, 'Wind'),
    D1WND1p5: pvar('DIV_WRF_MAX_WindMagKmh_SFC', null, 9.4, 'Max Wind'),
    KBDI: pvar(PREFIX_KBDI, null, 30, 'KBDI'),
    FMC: pvar('FMC', 16, null, 'L80 FMC', null, true),
    DP: na(),
    CURE: na()
  },
  [CODE.WIREGRASS_MATURE]: {
    FFDI: showNonFinal(),
    GFDI: naNonFinal(),
    D1FDI: pvar('MAX_FFDI_DAY1', null, 8, 'Max FDI'),
    D2FDI: na(),
    TEMP: pvar(PREFIX_T, null, 25, 'Temp'),
    RH: pvar(PREFIX_RH, 45, null, 'RH', null, true),
    WND10: pvar(PREFIX_WIND_MAG_KTS, null, 20, 'Wind'),
    D1WND10: pvar('MAX_WindMagKmh_SFC', null, 20, 'Max Wind'),
    WND1p5: pvar('DIV_WRF_' + PREFIX_WIND_MAG_KTS, null, 12.5, 'Wind'),
    D1WND1p5: pvar('DIV_WRF_MAX_WindMagKmh_SFC', null, 12.5, 'Max Wind'),
    KBDI: pvar(PREFIX_KBDI, null, 30, 'KBDI'),
    FMC: pvar('FMC', 16, null, 'L80 FMC', null, true),
    DP: na(),
    CURE: na()
  },
  [CODE.HEATHLANDS]: {
    FFDI: showNonFinal(),
    GFDI: naNonFinal(),
    D1FDI: pvar('MAX_FFDI_DAY1', null, 4, 'Max FDI'),
    D2FDI: na(),
    TEMP: pvar(PREFIX_T, 17, 25, 'Temp'),
    RH: pvar(PREFIX_RH, 45, 80, 'RH', null, true),
    WND10: pvar(PREFIX_WIND_MAG_KTS, null, 15, 'Wind'),
    D1WND10: pvar('MAX_WindMagKmh_SFC', null, 15, 'Max Wind'),
    WND1p5: pvar('DIV_WRF_' + PREFIX_WIND_MAG_KTS, null, 9.4, 'Wind'),
    D1WND1p5: pvar('DIV_WRF_MAX_WindMagKmh_SFC', null, 9.4, 'Max Wind'),
    KBDI: pvar(PREFIX_KBDI, null, 30, 'KBDI'),
    FMC: na(),
    DP: na(),
    CURE: na()
  },
  [CODE.MALLEE]: {
    FFDI: showNonFinal(),
    GFDI: naNonFinal(),
    D1FDI: pvar('MAX_FFDI_DAY1', null, 20, 'Max FDI'),
    D2FDI: na(),
    TEMP: pvar(PREFIX_T, 12, 28, 'Temp'),
    RH: pvar(PREFIX_RH, 25, 60, 'RH', null, true),
    WND10: pvar(PREFIX_WIND_MAG_KTS, null, 25, 'Wind'),
    D1WND10: pvar('MAX_WindMagKmh_SFC', null, 25, 'Max Wind'),
    WND1p5: pvar('DIV_WRF_' + PREFIX_WIND_MAG_KTS, null, 15.6, 'Wind'),
    D1WND1p5: pvar('DIV_WRF_MAX_WindMagKmh_SFC', null, 15.6, 'Max Wind'),
    KBDI: pvar(PREFIX_KBDI, null, 150, 'KBDI'),
    FMC: na(),
    DP: na(),
    CURE: na()
  },
  [CODE.GRASSLANDS]: {
    FFDI: naNonFinal(),
    GFDI: showNonFinal(),
    D1FDI: pvar('MAX_GFDI_DAY1', null, 8, 'Max FDI'),
    D2FDI: na(),
    TEMP: pvar(PREFIX_T, null, 30, 'Temp'),
    RH: pvar(PREFIX_RH, 30, null, 'RH', null, true),
    WND10: pvar(PREFIX_WIND_MAG_KTS, null, 15, 'Wind'),
    D1WND10: pvar('MAX_WindMagKmh_SFC', null, 15, 'Max Wind'),
    WND1p5: pvar('DIV_WRF_' + PREFIX_WIND_MAG_KTS, null, 9.4, 'Wind'),
    D1WND1p5: pvar('DIV_WRF_MAX_WindMagKmh_SFC', null, 9.4, 'Max Wind'),
    KBDI: pvar(PREFIX_KBDI, null, 100, 'KBDI'),
    FMC: na(),
    DP: na(),
    CURE: pvar(PREFIX_CURING, 80, null, 'Curing')
  },
  [CODE.ASH]: {
    FFDI: showNonFinal(),
    GFDI: naNonFinal(),
    D1FDI: pvar('MAX_FFDI_DAY1', null, 10, 'Max FDI'),
    D2FDI: pvar('MAX_FFDI_DAY2', null, 18, 'Max FDI'),
    TEMP: pvar(PREFIX_T, 18, 28, 'Temp'),
    RH: pvar(PREFIX_RH, 35, 80, 'RH', null, true),
    WND10: pvar(PREFIX_WIND_MAG_KTS, null, 20, 'Wind'),
    D1WND10: pvar('MAX_WindMagKmh_SFC', null, 20, 'Max Wind'),
    WND1p5: pvar('DIV_WRF_' + PREFIX_WIND_MAG_KTS, null, 12.5, 'Wind'),
    D1WND1p5: pvar('DIV_WRF_MAX_WindMagKmh_SFC', null, 12.5, 'Max Wind'),
    KBDI: pvar(PREFIX_KBDI, null, 100, 'KBDI'),
    FMC: pvar('FMC', null, 14, 'L80 FMC', null, true),
    DP: na(),
    CURE: na()
  },
  [CODE.SOFTWOOD]: {
    FFDI: showNonFinal(),
    GFDI: naNonFinal(),
    D1FDI: pvar('MAX_FFDI_DAY1', null, 10, 'Max FDI'),
    D2FDI: pvar('MAX_FFDI_DAY2', null, 18, 'Max FDI'),
    TEMP: pvar(PREFIX_T, null, 28, 'Temp'),
    RH: pvar(PREFIX_RH, 40, null, 'RH', null, true),
    WND10: pvar(PREFIX_WIND_MAG_KTS, null, 10, 'Wind'),
    D1WND10: pvar('MAX_WindMagKmh_SFC', null, 10, 'Max Wind'),
    WND1p5: pvar('DIV_WRF_' + PREFIX_WIND_MAG_KTS, null, 6.25, 'Wind'),
    D1WND1p5: pvar('DIV_WRF_MAX_WindMagKmh_SFC', null, 6.25, 'Max Wind'),
    KBDI: pvar(PREFIX_KBDI, null, 100, 'KBDI'),
    FMC: na(),
    DP: na(),
    CURE: na()
  },
  [CODE.WINDROS_DRY_SCLEROPHYLL]: {
    FFDI: showNonFinal(),
    GFDI: naNonFinal(),
    D1FDI: pvar('MAX_FFDI_DAY1', null, 10, 'Max FDI'),
    D2FDI: pvar('MAX_FFDI_DAY2', null, 12, 'Max FDI'),
    TEMP: pvar(PREFIX_T, 18, 27, 'Temp'),
    RH: pvar(PREFIX_RH, 35, 70, 'RH', null, true),
    WND10: pvar(PREFIX_WIND_MAG_KTS, null, 20, 'Wind'),
    D1WND10: pvar('MAX_WindMagKmh_SFC', null, 20, 'Max Wind'),
    WND1p5: pvar('DIV_WRF_' + PREFIX_WIND_MAG_KTS, null, 12.5, 'Wind'),
    D1WND1p5: pvar('DIV_WRF_MAX_WindMagKmh_SFC', null, 12.5, 'Max Wind'),
    KBDI: pvar(PREFIX_KBDI, null, 50, 'KBDI'),
    FMC: pvar('FMC', 12, 14, 'L80 FMC', null, true),
    DP: na(),
    CURE: na()
  },
  [CODE.WINDROS_ASH]: {
    FFDI: showNonFinal(),
    GFDI: naNonFinal(),
    D1FDI: pvar('MAX_FFDI_DAY1', null, 10, 'Max FDI'),
    D2FDI: pvar('MAX_FFDI_DAY2', null, 18, 'Max FDI'),
    TEMP: pvar(PREFIX_T, 18, 28, 'Temp'),
    RH: pvar(PREFIX_RH, 35, 80, 'RH', null, true),
    WND10: pvar(PREFIX_WIND_MAG_KTS, null, 20, 'Wind'),
    D1WND10: pvar('MAX_WindMagKmh_SFC', null, 20, 'Max Wind'),
    WND1p5: pvar('DIV_WRF_' + PREFIX_WIND_MAG_KTS, null, 12.5, 'Wind'),
    D1WND1p5: pvar('DIV_WRF_MAX_WindMagKmh_SFC', null, 12.5, 'Max Wind'),
    KBDI: pvar(PREFIX_KBDI, null, 100, 'KBDI'),
    FMC: pvar('FMC', 12, 14, 'L80 FMC', null, true),
    DP: na(),
    CURE: na()
  },
  [CODE.WINDROS_SOFTWOOD]: {
    FFDI: showNonFinal(),
    GFDI: naNonFinal(),
    D1FDI: pvar('MAX_FFDI_DAY1', null, 10, 'Max FDI'),
    D2FDI: pvar('MAX_FFDI_DAY2', null, 18, 'Max FDI'),
    TEMP: pvar(PREFIX_T, null, 28, 'Temp'),
    RH: pvar(PREFIX_RH, 40, null, 'RH', null, true),
    WND10: pvar(PREFIX_WIND_MAG_KTS, null, 10, 'Wind'),
    D1WND10: pvar('MAX_WindMagKmh_SFC', null, 10, 'Max Wind'),
    WND1p5: pvar('DIV_WRF_' + PREFIX_WIND_MAG_KTS, null, 6.25, 'Wind'),
    D1WND1p5: pvar('DIV_WRF_MAX_WindMagKmh_SFC', null, 6.25, 'Max Wind'),
    KBDI: pvar(PREFIX_KBDI, null, 100, 'KBDI'),
    FMC: pvar('FMC', 12, 14, 'L80 FMC', null, true),
    DP: na(),
    CURE: na()
  },
  [CODE.HEADS_DISPOSAL]: {
    FFDI: showNonFinal(),
    GFDI: naNonFinal(),
    D1FDI: pvar('MAX_FFDI_DAY1', null, 5, 'Max FDI'),
    D2FDI: na(),
    TEMP: pvar(PREFIX_T, null, 22, 'Temp'),
    RH: pvar(PREFIX_RH, null, 50, 'RH', null, true),
    WND10: pvar(PREFIX_WIND_MAG_KTS, null, 15, 'Wind'),
    D1WND10: pvar('MAX_WindMagKmh_SFC', null, 15, 'Max Wind'),
    WND1p5: pvar('DIV_WRF_' + PREFIX_WIND_MAG_KTS, null, 9.4, 'Wind'),
    D1WND1p5: pvar('DIV_WRF_MAX_WindMagKmh_SFC', null, 9.4, 'Max Wind'),
    KBDI: pvar(PREFIX_KBDI, null, 20, 'KBDI'),
    FMC: pvar('FMC', null, 18, 'L80 FMC', null, true),
    DP: na(),
    CURE: na()
  },
  [CODE.CFA_GRASSLANDS]: {
    FFDI: naNonFinal(),
    GFDI: showNonFinal(),
    D1FDI: pvar('MAX_GFDI_DAY1', null, 10, 'Max FDI'),
    D2FDI: na(),
    TEMP: pvar(PREFIX_T, null, 32, 'Temp'),
    RH: pvar(PREFIX_RH, 30, null, 'RH', null, true),
    WND10: na(),
    D1WND10: na(),
    WND1p5: pvar('DIV_WRF_' + PREFIX_WIND_MAG_KTS, null, 15, 'Wind'),
    D1WND1p5: pvar('DIV_WRF_MAX_WindMagKmh_SFC', null, 15, 'Max Wind'),
    KBDI: pvar(PREFIX_KBDI, null, 100, 'KBDI'),
    FMC: na(),
    DP: na(),
    CURE: pvar(PREFIX_CURING, 30, null, 'Curing')
  },
  [CODE.GIPPSLAND_LOW_INTENSITY]: {
    FFDI: showNonFinal(),
    GFDI: naNonFinal(),
    D1FDI: pvar('MAX_FFDI_DAY1', null, 10, 'Max FDI'),
    D2FDI: na(),
    TEMP: pvar(PREFIX_T, null, 27, 'Temp'),
    RH: pvar(PREFIX_RH, 35, null, 'RH', null, true),
    WND10: pvar(PREFIX_WIND_MAG_KTS, null, 20, 'Wind'),
    D1WND10: pvar('MAX_WindMagKmh_SFC', null, 20, 'Max Wind'),
    WND1p5: pvar('DIV_WRF_' + PREFIX_WIND_MAG_KTS, null, 15, 'Wind'),
    D1WND1p5: pvar('DIV_WRF_MAX_WindMagKmh_SFC', null, 15, 'Max Wind'),
    KBDI: pvar(PREFIX_KBDI, null, 100, 'KBDI'),
    FMC: pvar('FMC', 12, 18, 'L80 FMC', null, true),
    DP: na(),
    CURE: na()
  },
  [CODE.MATURE_COASTAL_TEA_TREE]: {
    FFDI: showNonFinal(),
    GFDI: naNonFinal(),
    D1FDI: pvar('MAX_FFDI_DAY1', null, 20, 'Max FDI'),
    D2FDI: na(),
    TEMP: pvar(PREFIX_T, 16, 26, 'Temp'),
    RH: pvar(PREFIX_RH, 40, 70, 'RH', null, true),
    WND10: pvar(PREFIX_WIND_MAG_KTS, null, 40, 'Wind'),
    D1WND10: pvar('MAX_WindMagKmh_SFC', null, 40, 'Max Wind'),
    WND1p5: pvar('DIV_WRF_' + PREFIX_WIND_MAG_KTS, null, 15, 'Wind'),
    D1WND1p5: pvar('DIV_WRF_MAX_WindMagKmh_SFC', null, 15, 'Max Wind'),
    KBDI: pvar(PREFIX_KBDI, null, 100, 'KBDI'),
    FMC: na(),
    DP: na(),
    CURE: na()
  },
  [CODE.MIDLANDS_DRY_WITH_WIREGRASS]: {
    FFDI: showNonFinal(),
    GFDI: naNonFinal(),
    D1FDI: pvar('MAX_FFDI_DAY1', null, 12, 'Max FDI'),
    D2FDI: na(),
    TEMP: pvar(PREFIX_T, null, 28, 'Temp'),
    RH: pvar(PREFIX_RH, 30, 70, 'RH', null, true),
    WND10: pvar(PREFIX_WIND_MAG_KTS, null, 25, 'Wind'),
    D1WND10: pvar('MAX_WindMagKmh_SFC', null, 25, 'Max Wind'),
    WND1p5: pvar('DIV_WRF_' + PREFIX_WIND_MAG_KTS, null, 15.6, 'Wind'),
    D1WND1p5: pvar('DIV_WRF_MAX_WindMagKmh_SFC', null, 15.6, 'Max Wind'),
    KBDI: pvar(PREFIX_KBDI, null, 50, 'KBDI'),
    FMC: pvar('FMC', 10, 15, 'L80 FMC', null, true),
    DP: na(),
    CURE: na()
  },
  [CODE.MIDLANDS_DRY_WITHOUT_WIREGRASS]: {
    FFDI: showNonFinal(),
    GFDI: naNonFinal(),
    D1FDI: pvar('MAX_FFDI_DAY1', null, 12, 'Max FDI'),
    D2FDI: na(),
    TEMP: pvar(PREFIX_T, null, 30, 'Temp'),
    RH: pvar(PREFIX_RH, 30, 70, 'RH', null, true),
    WND10: pvar(PREFIX_WIND_MAG_KTS, null, 30, 'Wind'),
    D1WND10: pvar('MAX_WindMagKmh_SFC', null, 30, 'Max Wind'),
    WND1p5: pvar('DIV_WRF_' + PREFIX_WIND_MAG_KTS, null, 18.7, 'Wind'),
    D1WND1p5: pvar('DIV_WRF_MAX_WindMagKmh_SFC', null, 18.7, 'Max Wind'),
    KBDI: pvar(PREFIX_KBDI, null, 50, 'KBDI'),
    FMC: pvar('FMC', 9, 15, 'L80 FMC', null, true),
    DP: na(),
    CURE: na()
  },
  [CODE.MILDURA_HEATH_CONTINOUS]: {
    FFDI: showNonFinal(),
    GFDI: naNonFinal(),
    D1FDI: pvar('MAX_FFDI_DAY1', null, 20, 'Max FDI'),
    D2FDI: na(),
    TEMP: pvar(PREFIX_T, null, 28, 'Temp'),
    RH: pvar(PREFIX_RH, 35, null, 'RH', null, true),
    WND10: pvar(PREFIX_WIND_MAG_KTS, null, 15, 'Wind'),
    D1WND10: pvar('MAX_WindMagKmh_SFC', null, 15, 'Max Wind'),
    WND1p5: pvar('DIV_WRF_' + PREFIX_WIND_MAG_KTS, null, 13, 'Wind'),
    D1WND1p5: pvar('DIV_WRF_MAX_WindMagKmh_SFC', null, 13, 'Max Wind'),
    KBDI: pvar(PREFIX_KBDI, null, 150, 'KBDI'),
    FMC: na(),
    DP: pvar('Td_SFC', 0, null, 'Dew Point', 20),
    CURE: na()
  },
  [CODE.MILDURA_HEATH_CONTINOUS_UNBOUNDED]: {
    FFDI: showNonFinal(),
    GFDI: naNonFinal(),
    D1FDI: pvar('MAX_FFDI_DAY1', null, 20, 'Max FDI'),
    D2FDI: na(),
    TEMP: pvar(PREFIX_T, null, 28, 'Temp'),
    RH: pvar(PREFIX_RH, 80, null, 'RH', null, true),
    WND10: pvar(PREFIX_WIND_MAG_KTS, null, 15, 'Wind'),
    D1WND10: pvar('MAX_WindMagKmh_SFC', null, 15, 'Max Wind'),
    WND1p5: pvar('DIV_WRF_' + PREFIX_WIND_MAG_KTS, null, 13, 'Wind'),
    D1WND1p5: pvar('DIV_WRF_MAX_WindMagKmh_SFC', null, 13, 'Max Wind'),
    KBDI: pvar(PREFIX_KBDI, null, 150, 'KBDI'),
    FMC: na(),
    DP: pvar('Td_SFC', 4, null, 'Dew Point', 20),
    CURE: na()
  },
  [CODE.MILDURA_HEATH_DISCONTINUOS]: {
    FFDI: showNonFinal(),
    GFDI: naNonFinal(),
    D1FDI: pvar('MAX_FFDI_DAY1', null, 25, 'Max FDI'),
    D2FDI: na(),
    TEMP: pvar(PREFIX_T, null, 32, 'Temp'),
    RH: pvar(PREFIX_RH, 25, null, 'RH', null, true),
    WND10: pvar(PREFIX_WIND_MAG_KTS, null, 20, 'Wind'),
    D1WND10: pvar('MAX_WindMagKmh_SFC', null, 20, 'Max Wind'),
    WND1p5: pvar('DIV_WRF_' + PREFIX_WIND_MAG_KTS, null, 16, 'Wind'),
    D1WND1p5: pvar('DIV_WRF_MAX_WindMagKmh_SFC', null, 16, 'Max Wind'),
    KBDI: pvar(PREFIX_KBDI, null, 150, 'KBDI'),
    FMC: na(),
    DP: pvar('Td_SFC', 0, null, 'Dew Point', 20),
    CURE: na()
  },
  [CODE.MILDURA_HEATH_DISCONTINUOS_UNBOUNDED]: {
    FFDI: showNonFinal(),
    GFDI: naNonFinal(),
    D1FDI: pvar('MAX_FFDI_DAY1', null, 25, 'Max FDI'),
    D2FDI: na(),
    TEMP: pvar(PREFIX_T, null, 32, 'Temp'),
    RH: pvar(PREFIX_RH, 80, null, 'RH', null, true),
    WND10: pvar(PREFIX_WIND_MAG_KTS, null, 20, 'Wind'),
    D1WND10: pvar('MAX_WindMagKmh_SFC', null, 20, 'Max Wind'),
    WND1p5: pvar('DIV_WRF_' + PREFIX_WIND_MAG_KTS, null, 16, 'Wind'),
    D1WND1p5: pvar('DIV_WRF_MAX_WindMagKmh_SFC', null, 16, 'Max Wind'),
    KBDI: pvar(PREFIX_KBDI, null, 150, 'KBDI'),
    FMC: na(),
    DP: pvar('Td_SFC', 4, null, 'Dew Point', 20),
    CURE: na()
  },
  [CODE.MILDURA_MALLEE_WITH_TRIODIA]: {
    FFDI: showNonFinal(),
    GFDI: naNonFinal(),
    D1FDI: pvar('MAX_FFDI_DAY1', null, 15, 'Max FDI'),
    D2FDI: na(),
    TEMP: pvar(PREFIX_T, null, 15, 'Temp'),
    RH: pvar(PREFIX_RH, 40, null, 'RH', null, true),
    WND10: pvar(PREFIX_WIND_MAG_KTS, null, 10, 'Wind'),
    D1WND10: pvar('MAX_WindMagKmh_SFC', null, 10, 'Max Wind'),
    WND1p5: pvar('DIV_WRF_' + PREFIX_WIND_MAG_KTS, null, 10, 'Wind'),
    D1WND1p5: pvar('DIV_WRF_MAX_WindMagKmh_SFC', null, 10, 'Max Wind'),
    KBDI: pvar(PREFIX_KBDI, null, 150, 'KBDI'),
    FMC: na(),
    DP: pvar('Td_SFC', 0, null, 'Dew Point', 20),
    CURE: na()
  },
  [CODE.MILDURA_MALLEE_WITH_TRIODIA_UNBOUNDED]: {
    FFDI: showNonFinal(),
    GFDI: naNonFinal(),
    D1FDI: pvar('MAX_FFDI_DAY1', null, 15, 'Max FDI'),
    D2FDI: na(),
    TEMP: pvar(PREFIX_T, null, 15, 'Temp'),
    RH: pvar(PREFIX_RH, 80, null, 'RH', null, true),
    WND10: pvar(PREFIX_WIND_MAG_KTS, null, 10, 'Wind'),
    D1WND10: pvar('MAX_WindMagKmh_SFC', null, 10, 'Max Wind'),
    WND1p5: pvar('DIV_WRF_' + PREFIX_WIND_MAG_KTS, null, 10, 'Wind'),
    D1WND1p5: pvar('DIV_WRF_MAX_WindMagKmh_SFC', null, 10, 'Max Wind'),
    KBDI: pvar(PREFIX_KBDI, null, 150, 'KBDI'),
    FMC: na(),
    DP: pvar('Td_SFC', 4, null, 'Dew Point', 20),
    CURE: na()
  },
  [CODE.MILDURA_MALLEE_WITHOUT_TRIODIA]: {
    FFDI: showNonFinal(),
    GFDI: naNonFinal(),
    D1FDI: pvar('MAX_FFDI_DAY1', null, 20, 'Max FDI'),
    D2FDI: na(),
    TEMP: pvar(PREFIX_T, null, 20, 'Temp'),
    RH: pvar(PREFIX_RH, 35, null, 'RH', null, true),
    WND10: pvar(PREFIX_WIND_MAG_KTS, null, 15, 'Wind'),
    D1WND10: pvar('MAX_WindMagKmh_SFC', null, 15, 'Max Wind'),
    WND1p5: pvar('DIV_WRF_' + PREFIX_WIND_MAG_KTS, null, 16, 'Wind'),
    D1WND1p5: pvar('DIV_WRF_MAX_WindMagKmh_SFC', null, 16, 'Max Wind'),
    KBDI: pvar(PREFIX_KBDI, null, 150, 'KBDI'),
    FMC: na(),
    DP: pvar('Td_SFC', 0, null, 'Dew Point', 20),
    CURE: na()
  },
  [CODE.MILDURA_MALLEE_WITHOUT_TRIODIA_UNBOUNDED]: {
    FFDI: showNonFinal(),
    GFDI: naNonFinal(),
    D1FDI: pvar('MAX_FFDI_DAY1', null, 20, 'Max FDI'),
    D2FDI: na(),
    TEMP: pvar(PREFIX_T, null, 20, 'Temp'),
    RH: pvar(PREFIX_RH, 80, null, 'RH', null, true),
    WND10: pvar(PREFIX_WIND_MAG_KTS, null, 15, 'Wind'),
    D1WND10: pvar('MAX_WindMagKmh_SFC', null, 15, 'Max Wind'),
    WND1p5: pvar('DIV_WRF_' + PREFIX_WIND_MAG_KTS, null, 16, 'Wind'),
    D1WND1p5: pvar('DIV_WRF_MAX_WindMagKmh_SFC', null, 16, 'Max Wind'),
    KBDI: pvar(PREFIX_KBDI, null, 150, 'KBDI'),
    FMC: na(),
    DP: pvar('Td_SFC', 4, null, 'Dew Point', 20),
    CURE: na()
  },
  [CODE.GOLDFIELDS_IRONBARK]: {
    FFDI: showNonFinal(),
    GFDI: naNonFinal(),
    D1FDI: pvar('MAX_FFDI_DAY1', 8, 20, 'Max FDI'),
    D2FDI: na(),
    TEMP: pvar(PREFIX_T, null, 30, 'Temp'),
    RH: pvar(PREFIX_RH, 30, null, 'RH', null, true),
    WND10: pvar(PREFIX_WIND_MAG_KTS, null, 25, 'Wind'),
    D1WND10: pvar('MAX_WindMagKmh_SFC', null, 25, 'Max Wind'),
    WND1p5: pvar('DIV_WRF_' + PREFIX_WIND_MAG_KTS, null, 15.6, 'Wind'),
    D1WND1p5: pvar('DIV_WRF_MAX_WindMagKmh_SFC', null, 15.6, 'Max Wind'),
    KBDI: pvar(PREFIX_KBDI, null, 80, 'KBDI'),
    FMC: pvar('FMC', 8, 12, 'L80 FMC', null, true),
    DP: na(),
    CURE: na()
  },
  [CODE.GOLDFIELDS_STRINGYBARK]: {
    FFDI: showNonFinal(),
    GFDI: naNonFinal(),
    D1FDI: pvar('MAX_FFDI_DAY1', 6, 16, 'Max FDI'),
    D2FDI: na(),
    TEMP: pvar(PREFIX_T, null, 28, 'Temp'),
    RH: pvar(PREFIX_RH, 30, null, 'RH', null, true),
    WND10: pvar(PREFIX_WIND_MAG_KTS, null, 20, 'Wind'),
    D1WND10: pvar('MAX_WindMagKmh_SFC', null, 20, 'Max Wind'),
    WND1p5: pvar('DIV_WRF_' + PREFIX_WIND_MAG_KTS, null, 12.5, 'Wind'),
    D1WND1p5: pvar('DIV_WRF_MAX_WindMagKmh_SFC', null, 12.5, 'Max Wind'),
    KBDI: pvar(PREFIX_KBDI, null, 80, 'KBDI'),
    FMC: pvar('FMC', 8, 12, 'L80 FMC', null, true),
    DP: na(),
    CURE: na()
  },
  [CODE.GOLDFIELDS_MIXED]: {
    FFDI: showNonFinal(),
    GFDI: naNonFinal(),
    D1FDI: pvar('MAX_FFDI_DAY1', 4, 10, 'Max FDI'),
    D2FDI: na(),
    TEMP: pvar(PREFIX_T, null, 27, 'Temp'),
    RH: pvar(PREFIX_RH, 35, null, 'RH', null, true),
    WND10: pvar(PREFIX_WIND_MAG_KTS, null, 20, 'Wind'),
    D1WND10: pvar('MAX_WindMagKmh_SFC', null, 20, 'Max Wind'),
    WND1p5: pvar('DIV_WRF_' + PREFIX_WIND_MAG_KTS, null, 12.5, 'Wind'),
    D1WND1p5: pvar('DIV_WRF_MAX_WindMagKmh_SFC', null, 12.5, 'Max Wind'),
    KBDI: pvar(PREFIX_KBDI, null, 50, 'KBDI'),
    FMC: pvar('FMC', 9, 16, 'L80 FMC', null, true),
    DP: na(),
    CURE: na()
  },
  [CODE.MURRINDINDI_STRINGYBARK]: {
    FFDI: showNonFinal(),
    GFDI: naNonFinal(),
    D1FDI: pvar('MAX_FFDI_DAY1', null, 10, 'Max FDI'),
    D2FDI: na(),
    TEMP: pvar(PREFIX_T, 10, null, 'Temp'),
    RH: pvar(PREFIX_RH, 35, 60, 'RH', null, true),
    WND10: pvar(PREFIX_WIND_MAG_KTS, null, 20, 'Wind'),
    D1WND10: pvar('MAX_WindMagKmh_SFC', null, 20, 'Max Wind'),
    WND1p5: pvar('DIV_WRF_' + PREFIX_WIND_MAG_KTS, null, 12.5, 'Wind'),
    D1WND1p5: pvar('DIV_WRF_MAX_WindMagKmh_SFC', null, 12.5, 'Max Wind'),
    KBDI: pvar(PREFIX_KBDI, null, 50, 'KBDI'),
    FMC: pvar('FMC', 20, null, 'L80 FMC', null, true),
    DP: na(),
    CURE: na()
  },
  [CODE.MURRINDINDI_DRY_SCLEROPHYLL]: {
    FFDI: showNonFinal(),
    GFDI: naNonFinal(),
    D1FDI: pvar('MAX_FFDI_DAY1', 5, 11, 'Max FDI'),
    D2FDI: na(),
    TEMP: pvar(PREFIX_T, null, 25, 'Temp'),
    RH: pvar(PREFIX_RH, 30, 70, 'RH', null, true),
    WND10: pvar(PREFIX_WIND_MAG_KTS, null, 20, 'Wind'),
    D1WND10: pvar('MAX_WindMagKmh_SFC', null, 20, 'Max Wind'),
    WND1p5: pvar('DIV_WRF_' + PREFIX_WIND_MAG_KTS, null, 15, 'Wind'),
    D1WND1p5: pvar('DIV_WRF_MAX_WindMagKmh_SFC', null, 15, 'Max Wind'),
    KBDI: pvar(PREFIX_KBDI, null, 50, 'KBDI'),
    FMC: pvar('FMC', 11, 16, 'L80 FMC', null, true),
    DP: na(),
    CURE: na()
  },
  [CODE.MURRINDINDI_MIXED]: {
    FFDI: showNonFinal(),
    GFDI: naNonFinal(),
    D1FDI: pvar('MAX_FFDI_DAY1', null, 10, 'Max FDI'),
    D2FDI: na(),
    TEMP: pvar(PREFIX_T, 18, 27, 'Temp'),
    RH: pvar(PREFIX_RH, 35, 70, 'RH', null, true),
    WND10: pvar(PREFIX_WIND_MAG_KTS, null, 20, 'Wind'),
    D1WND10: pvar('MAX_WindMagKmh_SFC', null, 20, 'Max Wind'),
    WND1p5: pvar('DIV_WRF_' + PREFIX_WIND_MAG_KTS, null, 10, 'Wind'),
    D1WND1p5: pvar('DIV_WRF_MAX_WindMagKmh_SFC', null, 10, 'Max Wind'),
    KBDI: pvar(PREFIX_KBDI, null, 50, 'KBDI'),
    FMC: pvar('FMC', 16, null, 'L80 FMC', null, true),
    DP: na(),
    CURE: na()
  },
  [CODE.NE_HIGH_INTENSITY]: {
    FFDI: showNonFinal(),
    GFDI: naNonFinal(),
    D1FDI: pvar('MAX_FFDI_DAY1', null, 10, 'Max FDI'),
    D2FDI: na(),
    TEMP: pvar(PREFIX_T, null, 28, 'Temp'),
    RH: pvar(PREFIX_RH, 35, null, 'RH', null, true),
    WND10: pvar(PREFIX_WIND_MAG_KTS, null, 20, 'Wind'),
    D1WND10: pvar('MAX_WindMagKmh_SFC', null, 20, 'Max Wind'),
    WND1p5: pvar('DIV_WRF_' + PREFIX_WIND_MAG_KTS, null, 10, 'Wind'),
    D1WND1p5: pvar('DIV_WRF_MAX_WindMagKmh_SFC', null, 10, 'Max Wind'),
    KBDI: pvar(PREFIX_KBDI, null, 100, 'KBDI'),
    FMC: pvar('FMC', 4, 12, 'L80 FMC', null, true),
    DP: na(),
    CURE: na()
  },
  [CODE.NE_REDGUM]: {
    FFDI: showNonFinal(),
    GFDI: naNonFinal(),
    D1FDI: pvar('MAX_FFDI_DAY1', null, 11, 'Max FDI'),
    D2FDI: na(),
    TEMP: pvar(PREFIX_T, null, 30, 'Temp'),
    RH: pvar(PREFIX_RH, 30, null, 'RH', null, true),
    WND10: pvar(PREFIX_WIND_MAG_KTS, null, 20, 'Wind'),
    D1WND10: pvar('MAX_WindMagKmh_SFC', null, 20, 'Max Wind'),
    WND1p5: pvar('DIV_WRF_' + PREFIX_WIND_MAG_KTS, null, 14, 'Wind'),
    D1WND1p5: pvar('DIV_WRF_MAX_WindMagKmh_SFC', null, 14, 'Max Wind'),
    KBDI: pvar(PREFIX_KBDI, null, 80, 'KBDI'),
    FMC: pvar('FMC', 9, 16, 'L80 FMC', null, true),
    DP: na(),
    CURE: na()
  },
  [CODE.OTWAY_AREA_COASTAL]: {
    FFDI: showNonFinal(),
    GFDI: naNonFinal(),
    D1FDI: pvar('MAX_FFDI_DAY1', null, 8, 'Max FDI'),
    D2FDI: na(),
    TEMP: pvar(PREFIX_T, null, 25, 'Temp'),
    RH: pvar(PREFIX_RH, 45, null, 'RH', null, true),
    WND10: pvar(PREFIX_WIND_MAG_KTS, null, 15, 'Wind'),
    D1WND10: pvar('MAX_WindMagKmh_SFC', null, 15, 'Max Wind'),
    WND1p5: pvar('DIV_WRF_' + PREFIX_WIND_MAG_KTS, null, 9.4, 'Wind'),
    D1WND1p5: pvar('DIV_WRF_MAX_WindMagKmh_SFC', null, 9.4, 'Max Wind'),
    KBDI: pvar(PREFIX_KBDI, null, 30, 'KBDI'),
    FMC: pvar('FMC', 12, null, 'L80 FMC', null, true),
    DP: na(),
    CURE: na()
  },
  [CODE.OTWAY_AREA_HEATH]: {
    FFDI: showNonFinal(),
    GFDI: naNonFinal(),
    D1FDI: pvar('MAX_FFDI_DAY1', null, 6, 'Max FDI'),
    D2FDI: na(),
    TEMP: pvar(PREFIX_T, null, 25, 'Temp'),
    RH: pvar(PREFIX_RH, 50, null, 'RH', null, true),
    WND10: pvar(PREFIX_WIND_MAG_KTS, null, 10, 'Wind'),
    D1WND10: pvar('MAX_WindMagKmh_SFC', null, 10, 'Max Wind'),
    WND1p5: pvar('DIV_WRF_' + PREFIX_WIND_MAG_KTS, null, 6.25, 'Wind'),
    D1WND1p5: pvar('DIV_WRF_MAX_WindMagKmh_SFC', null, 6.25, 'Max Wind'),
    KBDI: pvar(PREFIX_KBDI, null, 30, 'KBDI'),
    FMC: pvar('FMC', 14, null, 'L80 FMC', null, true),
    DP: na(),
    CURE: na()
  },
  [CODE.OTWAY_HEAD_COASTAL]: {
    FFDI: showNonFinal(),
    GFDI: naNonFinal(),
    D1FDI: pvar('MAX_FFDI_DAY1', null, 5, 'Max FDI'),
    D2FDI: na(),
    TEMP: pvar(PREFIX_T, null, 22, 'Temp'),
    RH: pvar(PREFIX_RH, 50, null, 'RH', null, true),
    WND10: pvar(PREFIX_WIND_MAG_KTS, null, 15, 'Wind'),
    D1WND10: pvar('MAX_WindMagKmh_SFC', null, 15, 'Max Wind'),
    WND1p5: pvar('DIV_WRF_' + PREFIX_WIND_MAG_KTS, null, 9.4, 'Wind'),
    D1WND1p5: pvar('DIV_WRF_MAX_WindMagKmh_SFC', null, 9.4, 'Max Wind'),
    KBDI: pvar(PREFIX_KBDI, null, 20, 'KBDI'),
    FMC: pvar('FMC', 18, null, 'L80 FMC', null, true),
    DP: na(),
    CURE: na()
  },
  [CODE.OVENS_DRY_SCLEROPHYLL]: {
    FFDI: showNonFinal(),
    GFDI: naNonFinal(),
    D1FDI: pvar('MAX_FFDI_DAY1', null, 8, 'Max FDI'),
    D2FDI: na(),
    TEMP: pvar(PREFIX_T, null, 28, 'Temp'),
    RH: pvar(PREFIX_RH, 35, 70, 'RH', null, true),
    WND10: pvar(PREFIX_WIND_MAG_KTS, null, 20, 'Wind'),
    D1WND10: pvar('MAX_WindMagKmh_SFC', null, 20, 'Max Wind'),
    WND1p5: pvar('DIV_WRF_' + PREFIX_WIND_MAG_KTS, null, 10, 'Wind'),
    D1WND1p5: pvar('DIV_WRF_MAX_WindMagKmh_SFC', null, 10, 'Max Wind'),
    KBDI: pvar(PREFIX_KBDI, null, 50, 'KBDI'),
    FMC: pvar('FMC', 12, 16, 'L80 FMC', null, true),
    DP: na(),
    CURE: na()
  },
  [CODE.PORT_PHILLIP_LOW_HAZARD]: {
    FFDI: showNonFinal(),
    GFDI: naNonFinal(),
    D1FDI: pvar('MAX_FFDI_DAY1', null, 4, 'Max FDI'),
    D2FDI: pvar('MAX_FFDI_DAY2', null, 2, 'Max FDI'),
    TEMP: pvar(PREFIX_T, null, 17, 'Temp'),
    RH: pvar(PREFIX_RH, 35, 65, 'RH', null, true),
    WND10: pvar(PREFIX_WIND_MAG_KTS, null, 20, 'Wind'),
    D1WND10: pvar('MAX_WindMagKmh_SFC', null, 20, 'Max Wind'),
    WND1p5: pvar('DIV_WRF_' + PREFIX_WIND_MAG_KTS, null, 12.5, 'Wind'),
    D1WND1p5: pvar('DIV_WRF_MAX_WindMagKmh_SFC', null, 12.5, 'Max Wind'),
    KBDI: pvar(PREFIX_KBDI, null, 90, 'KBDI'),
    FMC: pvar('FMC', 16, null, 'L80 FMC', null, true),
    DP: na(),
    CURE: na()
  },
  [CODE.PORT_PHILLIP_CANDLING_MOD_TO_EXTREME]: {
    FFDI: showNonFinal(), GFDI: naNonFinal(),
    D1FDI: pvar('MAX_FFDI_DAY1', null, 4, 'Max FDI'),
    D2FDI: pvar('MAX_FFDI_DAY2', null, 2, 'Max FDI'),
    TEMP: pvar(PREFIX_T, null, 17, 'Temp'),
    RH: pvar(PREFIX_RH, 35, 65, 'RH', null, true),
    WND10: pvar(PREFIX_WIND_MAG_KTS, null, 20, 'Wind'),
    D1WND10: pvar('MAX_WindMagKmh_SFC', null, 20, 'Max Wind'),
    WND1p5: pvar('DIV_WRF_' + PREFIX_WIND_MAG_KTS, null, 12.5, 'Wind'),
    D1WND1p5: pvar('DIV_WRF_MAX_WindMagKmh_SFC', null, 12.5, 'Max Wind'),
    KBDI: pvar(PREFIX_KBDI, null, 80, 'KBDI'),
    FMC: pvar('FMC', 18, null, 'L80 FMC', null, true),
    DP: na(),
    CURE: na()
  },
  [CODE.PORT_PHILLIP_FUEL_REDUCTION]: {
    FFDI: showNonFinal(),
    GFDI: naNonFinal(),
    D1FDI: pvar('MAX_FFDI_DAY1', null, 13, 'Max FDI'),
    D2FDI: pvar('MAX_FFDI_DAY2', null, 13, 'Max FDI'),
    TEMP: pvar(PREFIX_T, null, 27, 'Temp'),
    RH: pvar(PREFIX_RH, 35, null, 'RH', null, true),
    WND10: pvar(PREFIX_WIND_MAG_KTS, null, 20, 'Wind'),
    D1WND10: pvar('MAX_WindMagKmh_SFC', null, 20, 'Max Wind'),
    WND1p5: pvar('DIV_WRF_' + PREFIX_WIND_MAG_KTS, null, 12.5, 'Wind'),
    D1WND1p5: pvar('DIV_WRF_MAX_WindMagKmh_SFC', null, 12.5, 'Max Wind'),
    KBDI: pvar(PREFIX_KBDI, null, 100, 'KBDI'),
    FMC: pvar('FMC', 12, null, 'L80 FMC', null, true),
    DP: na(),
    CURE: na()
  }
};

export const GRAPHS_CONFIG = [
  {
    variable: 'D1FDI',
    requireVariable: 'MAX_FFDI_DAY1',
    title: 'Forest Fire Danger Index - Day 1 ',
    id: 'FFDI_SFC_VS_GFDI_SFC_PB',
    idNote: 'Needs to share this id with the graph defined in graphs.json because we are using their data',
    type: 'LineChart',
    YAxisLabel: 'FDI',
    series: [
      {
        name: 'Forecast FFDI',
        source: 'geoserver',
        dataKey: 'HP_FFDI_SFC_PB',
        type: 'monotone',
        stroke: '#DC38C8',
        active: true
      }
    ]
  },
  {
    variable: 'D1FDI',
    requireVariable: 'MAX_GFDI_DAY1',
    title: 'Grass Fire Danger Index - Day 1 ',
    id: 'FFDI_SFC_VS_GFDI_SFC_PB',
    idNote: 'Needs to share this id with the graph defined in graphs.json because we are using their data',
    type: 'LineChart',
    YAxisLabel: 'FDI',
    series: [
      {
        name: 'Forecast GFDI',
        source: 'geoserver',
        dataKey: 'HP_GFDI_SFC_PB',
        type: 'monotone',
        stroke: '#DC38C8',
        active: true
      }
    ]
  },
  {
    variable: 'D2FDI',
    requireVariable: 'MAX_FFDI_DAY2',
    title: 'Forest Fire Danger Index - Day 2',
    id: 'FFDI_SFC_VS_GFDI_SFC_PB',
    idNote: 'Needs to share this id with the graph defined in graphs.json because we are using their data',
    type: 'LineChart',
    YAxisLabel: 'FDI',
    series: [
      {
        name: 'Forecast FFDI',
        source: 'geoserver',
        dataKey: 'HP_FFDI_SFC_PB',
        type: 'monotone',
        stroke: '#DC38C8',
        active: true
      }
    ]
  },
  {
    variable: 'D2FDI',
    requireVariable: 'MAX_GFDI_DAY2',
    title: 'Grass Fire Danger Index - Day 2',
    id: 'FFDI_SFC_VS_GFDI_SFC_PB',
    idNote: 'Needs to share this id with the graph defined in graphs.json because we are using their data',
    type: 'LineChart',
    YAxisLabel: 'FDI',
    series: [
      {
        name: 'Forecast GFDI',
        source: 'geoserver',
        dataKey: 'HP_GFDI_SFC_PB',
        type: 'monotone',
        stroke: '#DC38C8',
        active: true
      }
    ]
  },
  {
    variable: 'TEMP',
    title: 'Temperature',
    id: 'T_SFC_VS_DP',
    type: 'LineChart',
    YAxisLabel: 'Degrees C',
    series: [
      {
        name: 'Forecast Temperature',
        source: 'geoserver',
        dataKey: PREFIX_T,
        type: 'monotone',
        stroke: '#FFB644',
        active: true
      }
    ]
  },
  {
    title: 'Dew Point',
    variable: 'DP',
    id: 'Td_SFC',
    type: 'LineChart',
    YAxisLabel: 'Degrees C',
    series: [
      {
        name: 'Forecast Dew Point',
        source: 'geoserver',
        dataKey: 'FMC',
        type: 'monotone',
        stroke: '#FFB644',
        active: true
      }
    ]
  },
  {
    title: 'Relative Humidity',
    variable: 'RH',
    id: 'RH_SFC_VS_CC',
    type: 'LineChart',
    YAxisLabel: '%',
    series: [
      {
        name: 'Forecast Relative Humidity',
        source: 'geoserver',
        dataKey: PREFIX_RH,
        type: 'monotone',
        stroke: '#008CC4',
        active: true
      }
    ]
  },
  {
    title: 'Wind Speed 10m',
    variable: 'WND10',
    id: 'Wind_Dir_SFC_VS_WindMagKmh_SFC',
    type: 'LineChart',
    YAxisLabel: 'Km/h',
    series: [
      {
        name: 'Forecast Speed',
        source: 'geoserver',
        dataKey: PREFIX_WIND_MAG_KTS,
        type: 'monotone',
        stroke: '#FFB644',
        active: true
      }
    ]
  },
  {
    title: 'Leaflet 80 Fuel Moisture Content',
    variable: 'FMC',
    id: 'FMC',
    type: 'LineChart',
    YAxisLabel: '%',
    series: [
      {
        name: 'FMC(%)',
        source: 'geoserver',
        dataKey: 'FMC',
        type: 'monotone',
        stroke: '#FFB644',
        active: true
      }
    ]
  }
];



// WEBPACK FOOTER //
// ./src/config/prescriptions.js